import {
  BOOST,
  INDEED,
  JOVEO,
  POOL,
  REACH,
  SPRING,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';

const getChannelName = (channelSlug: string) => {
  switch (channelSlug) {
    case INDEED:
      return 'Indeed';
    case BOOST:
      return 'Boost';
    case SPRING:
      return 'Spring';
    case TALROO:
      return 'Talroo';
    case ZIPRECRUITER:
      return 'ZipRecruiter';
    case JOVEO:
      return 'Joveo';
    case REACH:
      return 'Reach';
    case POOL:
      return 'Pool';
    default:
      return channelSlug
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }
};

export { getChannelName };
